import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, getDocs, } from "firebase/firestore";
// import PaginationOld from '../pages/PaginationOld';
import { db } from '../../firebase'
import { Link } from "react-router-dom";



import {
    FacebookShareButton, WhatsappShareButton, WhatsappIcon,
    FacebookIcon, TwitterShareButton, EmailShareButton, EmailIcon,

    LinkedinShareButton,
    LinkedinIcon,
    TwitterIcon,
} from "react-share";



function Ppage() {
    const [setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showPerPage, setShowPerPage] = useState(51);
    const [pagination, setPagination] = useState({
        start: 0,
        end: showPerPage,
    });

    const onPaginationChange = (start, end) => {
        setPagination({ start: start, end: end });
    };
    const [searchTerm, setsearchTerm] = useState("");
    const [jeans, setJeans] = useState([])
    const navigate = useNavigate()

    const jeansCollectionRef = collection(db, "PRODUCTS PAGE");
    useEffect(() => {

        const getJeans = async () => {
            const data = await getDocs(jeansCollectionRef);
            setJeans(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
        }

        getJeans()
    }, [])
    return (

        <>
        
            <div className="album py-2">

                <div className="container">

                    <div className="row">

                        <div className="col-md-6">

                            <div className="card-body">
                                <input type="text" className="form-control" placeholder="Search" name="location"
                                    onChange={(e) => {
                                        setsearchTerm(e.target.value);
                                    }}
                                />
                                <div className="d-flex justify-content-between align-items-center">




                                </div>


                            </div>


                        </div>

                    </div>

                </div>
            </div>
            <div className="album py-4">

                <div className="container">

                    <div className="row">
                        {jeans.filter((val) => {
                            if (setsearchTerm === "") {
                                return val;
                            } else if (
                                val.title.toLowerCase().includes(searchTerm.toLowerCase())




                            ) {
                                return val;
                            }
                        }).slice(pagination.start, pagination.end).map((jayatriprint) => {
                            return (
                                <div className="col-md-4 mt-8" >
                                    <div className="card mb-4 border-White box ">
                                        <img className="card-img-top" src={jayatriprint.img} alt={jayatriprint.title} />
                                        <div className="card-body">
                                            <div className='nametext'>
                                                <h6 className="card-text"> <b>{jayatriprint.title}</b></h6>
                                                < h5 style={{color: "Darkblue"}}className="card-text"> ₹{jayatriprint.price} </h5>

                                            </div>

                                            <p className="card-text">{jayatriprint.des}</p>
                                        


                                          
                                        </div>
                                    </div>

                                </div>
                            )
                        })}
                    </div>
           

                </div>
            </div>

        </>

    );
}

export default Ppage;



